<template>
  <v-dialog v-model="dialog" max-width="700" persistent>
    <v-card v-if="send">
      <v-card-title>{{ send.snapshotSubject }}</v-card-title>
      <v-card-text>
        <div class="caption grey--text">To</div>
        <div class="body-2 mb-2">{{ send.snapshotExternalRecipients }}</div>
        <div v-if="send.snapshotAdditionalRecipients" class="caption grey--text">Additional Recipients</div>
        <div v-if="send.snapshotAdditionalRecipients" class="body-2 mb-2">{{ send.snapshotAdditionalRecipients }}</div>
        <div class="caption grey--text">Reviewers</div>
        <div class="body-2 mb-3">{{ send.snapshotReviewerEmails }}</div>
        <v-divider class="mb-3" />
        <v-card outlined class="pa-3 mb-3">
          <div v-html="send.snapshotBodyHtml"></div>
        </v-card>
        <div v-if="send.attachments && send.attachments.length > 0">
          <div class="caption grey--text">Attachments</div>
          <v-chip v-for="attachment in send.attachments" :key="attachment.id" small class="mr-1 mb-1">
            {{ attachment.fileName }}
          </v-chip>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('close')">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    sendId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      dialog: true,
      send: null
    }
  },
  methods: {
    loadSend () {
      // Always the snapshot, never live template content -- content is frozen at generation time.
      this.$store.dispatch('workflowEmailSends/getWorkflowEmailSend', { id: this.sendId })
        .then(send => { this.send = send })
    }
  },
  created () {
    this.loadSend()
  }
}
</script>
